import { Button, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'store/thunks/authThunks';

const RequestAccess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const roles = useSelector(({ auth }) => auth.currentTenantRoles);

  // Redirect immediately if roles are present — handles both post-login role
  // grants and users who navigate here directly with roles already assigned.
  useEffect(() => {
    if (roles?.length) navigate('/', { replace: true });
  }, [roles, navigate]);

  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='center'
      sx={{ minHeight: '100vh', px: 3, textAlign: 'center' }}
      spacing={2}
    >
      <Grid item>
        <Typography variant='h4' component='h1'>
          Access pending
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant='body1' sx={{ maxWidth: 560 }}>
          Welcome. It looks like your account does not currently have any roles or pharmacy
          facilities assigned. Please reach out to support to have access configured.
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant='body2' color='text.secondary' sx={{ maxWidth: 560 }}>
          Once support has confirmed your access, sign out and sign back in.
        </Typography>
      </Grid>
      <Grid item>
        <Button variant='outlined' onClick={() => dispatch(signOut())} sx={{ mt: 1 }}>
          Sign out
        </Button>
      </Grid>
    </Grid>
  );
};

export default RequestAccess;
